import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";
import { createModalConfig, ModalConfig } from "../../../Models/ModalConfig";

interface IndexEmailNotificationsProviderProps {
  parentId?: string;
  action?: string;
  children: ReactNode;
  callback?: () => void;
}

interface IndexEmailNotificationsContextValue {
  parentId?: string;
  action?: string;
  modalConfig: ModalConfig;
  setModalConfig: Dispatch<SetStateAction<ModalConfig>>;
  callback?: () => void;
}

const IndexEmailNotificationsContext = createContext<
  IndexEmailNotificationsContextValue | undefined
>(undefined);

const IndexEmailNotificationsProvider: React.FC<
  IndexEmailNotificationsProviderProps
> = ({ children, callback, action, parentId }) => {
  const [modalConfig, setModalConfig] = useState<ModalConfig>(
    createModalConfig()
  );

  return (
    <IndexEmailNotificationsContext.Provider
      value={{ modalConfig, setModalConfig, callback, action, parentId }}
    >
      {children}
    </IndexEmailNotificationsContext.Provider>
  );
};

const useIndexEmailNotificationsContext =
  (): IndexEmailNotificationsContextValue => {
    const context = useContext(IndexEmailNotificationsContext);
    if (!context) {
      throw new Error(
        "useIndexEmailNotificationsContext must be used within an IndexEmailNotificationsProvider"
      );
    }
    return context;
  };

export { IndexEmailNotificationsProvider, useIndexEmailNotificationsContext };
